// 剣舞の斬りの跡を、弾いた時 (ヒットストップ) に途中で切れて見えなくする比較版 (10-23 作者「剣のエフェクトが途中で切れてるように見えたり
//   するんだよね。騎士はそこをうまくやってたと思うんだけど、何が違う?」)。開発版 ?bladeTrailStop=full|knight。
//   違い (実測 scripts/probe_blade_trail_hitstop_1023.mjs): 騎士の薙ぎは弾いた瞬間に跡が 9 割伸びていて、細い線で根元は透明。
//   剣舞は当たりが振り始めの最初のコマに出るので、太い帯が半分 (p 0.45) のまま止めの 9〜10 コマ固まって宙に浮いていた。
//   full = 帯はそのまま、当たった瞬間から伸びきった跡を出す / knight = 騎士の描き方 (細い一本線・弾いた時に 9 割) にそろえる。
//   10-23 作者の答え「T-2 A 伸びきった帯」で full が配布版の既定。前の版は開発版 ?bladeTrailStop=now、knight は比較用に残す。
//   全ボス共通のヒットストップには触らない。useBladeDancerMotionV6 / useBladeDancerWaltzV7 の後に呼ぶ。
import { SMEAR_ARTS, type ContactSmearArc } from './render'
import { BLADE_DANCER_V6_SMEAR, BLADE_DANCER_W7_SMEAR } from './blade_dancer_art'

export type BladeTrailStop = 'now' | 'full' | 'knight'

export function parseBladeTrailStop(v: string | null): BladeTrailStop {
  return v === 'now' || v === 'knight' ? v : 'full'
}

export function useBladeTrailStop(mode: BladeTrailStop): void {
  if (mode === 'now') return
  for (const key of [...Object.keys(BLADE_DANCER_V6_SMEAR), ...Object.keys(BLADE_DANCER_W7_SMEAR)]) {
    const art = SMEAR_ARTS[key] as ContactSmearArc | undefined
    if (!art || art.kind !== 'arc') continue
    if (mode === 'full') {
      SMEAR_ARTS[key] = { ...art, afterContact: { fromP: 1, revealMs: 0, holdMs: 70, fadeMs: 200 } }
    } else {
      // 騎士の薙ぎ (render.ts lanceSweep_contact) と同じ太さ・濃さ・時計。止めの間の伸びも騎士の実測 (0.90) にそろえる。
      const { trail: _t, trailWidthPx: _w, sparks: _s, petals: _p, ...rest } = art
      SMEAR_ARTS[key] = { ...rest, widthPx: 8, maxAlpha: 0.85, afterContact: { fromP: 0.9, revealMs: 33, holdMs: 50, fadeMs: 100 } }
    }
  }
}
